import {
  SEND_OTP,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  RESET_VERIFY_OTP_STATE,
  RESET_LOGIN_STATE,
} from "./loginTypes";

export const sendOtp = ({ mobileNumber }) => {
  return {
    type: SEND_OTP,
    payload: mobileNumber,
  };
};

export const sendOtpSuccess = () => {
  return {
    type: SEND_OTP_SUCCESS,
  };
};

export const sendOtpFailure = ({ error }) => {
  return {
    type: SEND_OTP_FAILURE,
    payload: error,
  };
};

export const verifyOtp = ({ otp, mobileNumber, callbackFn }) => {
  return {
    type: VERIFY_OTP,
    payload: { otp, mobileNumber, callbackFn },
  };
};

export const verifyOtpSuccess = () => {
  return {
    type: VERIFY_OTP_SUCCESS,
  };
};

export const verifyOtpFailure = ({ error }) => {
  return {
    type: VERIFY_OTP_FAILURE,
    payload: error,
  };
};

export const resetVerifyOtpState = () => {
  return {
    type: RESET_VERIFY_OTP_STATE,
  };
};

export const resetLoginState = () => {
  return {
    type: RESET_LOGIN_STATE,
  };
};
